<template>
  <a-layout-sider :trigger="null" collapsible v-model="collapsed" :width='width'>
    <div class="logo">
      <a href="/login">
        <img src="../../assets/zzlogo1.png" alt="logo">
        <span>{{title}}</span>
      </a>
    </div>
    <a-menu :theme="theme" mode="inline" :defaultSelectedKeys="defaultSelectedKeys" @openChange="onOpenChange" :openKeys="openKeys">
      <template v-for="(item, index) in menuList">
        <template v-if="item.childs">
          <a-sub-menu :key="item.name">
            <span slot="title">
              <a-icon v-if="item.icon" :type="item.icon" />
              <span>{{item.CNname}}</span>
            </span>
            <template v-for="childrenItem in item.childs">
              <a-menu-item :key="childrenItem.name" @click="handleClick(childrenItem)">
                <a-icon v-if="childrenItem.icon" :type="childrenItem.icon" />
                <span>{{childrenItem.CNname}}</span>
              </a-menu-item>
            </template>
          </a-sub-menu>
        </template>
        <a-menu-item v-else :key="item.CNname" @click="handleClick(item)">
          <a-icon v-if="item.icon" :type="item.icon" />
          <span>{{item.CNname}}</span>
        </a-menu-item>
      </template>
    </a-menu>
  </a-layout-sider>
</template>

<script>
  import {
    mapGetters,
    mapMutations,
    mapActions
  } from 'vuex';
  export default {
    props: {
      width: {
        type: Number,
        default: 256
      },
      title: {
        type: String,
        default: 'Antd Vue'
      },
      theme: {
        type: String,
        default: 'dark'
      },
      menuList: {
        type: Array,
        default: []
      }
    },
    watch: {},
    computed: {
      ...mapGetters(["collapsed"]),
    },
    data() {
      return {
        defaultSelectedKeys: [this.$route.meta.cName],
        openKeys: [''],
      }
    },
    mounted() {
      let that = this;
    },
    methods: {
      ...mapActions([
        'addOneTabPage',
        'closeOneTabPage',
        'closeAllTabPage'
      ]),
      onOpenChange(openKeys) {
        if(openKeys.length !== 0){
          this.openKeys = [openKeys[1]];
        } else {
          this.openKeys = [''];
        }
      },
      handleClick(item) {
        // if(item.path) {
        //   this.addOneTabPage({page: item, $router: this.$router});
        // }
        this.$router.push({
          path: item.path
        }).catch(err => {
          console.log(err);
        })
      },
    }
  }
</script>

<style scoped lang="less">
  .logo {
    position: relative;
    height: 64px;
    padding-left: 24px;
    overflow: hidden;
    line-height: 64px;
    background: #002140;
    -webkit-transition: all .3s;
    transition: all .3s;
    display: block;
  }

  .logo img {
    height: 32px;
    width: 32px;
    display: inline-block;
    vertical-align: middle;
  }

  .logo span {
    color: #fff;
    font-size: 22px;
    font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
    font-weight: 600;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/views/main/leftSider.vue